import axios from '../../../common/api/axios';

export const getMaterialMasterData = async () => {
  const response = await axios.get(`/material-record`);
  // console.log({ response });
  return response.data;
};
